<div class="tile-view-carrousel">
  <div
    (click)="arrowClicked('left')"
    (mouseenter)="arrowHovered('left')"
    (mouseleave)="arrowUnHovered('left')"
    class="arrowAndCircle"
    title="View details about overall percentage value"
  >
    <img
      src="../../assets/images/keyboard_arrow_left-{{
        leftArrowActive ? 'active' : 'inactive'
      }}.svg"
      class="arrow"
    />
    <div
      class="circle"
      [ngClass]="leftArrowActive ? 'circle-active' : 'circle-inactive'"
    ></div>
  </div>
  <div
    (click)="arrowClicked('right')"
    (mouseenter)="arrowHovered('right')"
    (mouseleave)="arrowUnHovered('right')"
    class="arrowAndCircle"
    title="View details about change value by time period"
  >
    <div
      class="circle"
      [ngClass]="rightArrowActive ? 'circle-active' : 'circle-inactive'"
    ></div>
    <img
      src="../../assets/images/keyboard_arrow_right-{{
        rightArrowActive ? 'active' : 'inactive'
      }}.svg"
      class="arrow"
    />
  </div>
</div>
